import React, { useState } from "react";
import { motion } from "framer-motion";
import CareersSection from "../components/Careers/CareersSection";
import CareerForm from "../components/Careers/CareerForm";
import Footer from "../components/Footer";
import Topbar from "../components/Topbar";
import Navbar from "../components/Navbar";
import Banner from "../components/CareerBanner";
import CareersFAQ from "../components/Careers/CareersFAQ";


function Offers() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupContent, setPopupContent] = useState(null);

  const openPopup = (content) => {
    setPopupContent(content);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setPopupContent(null);
  };


  return (
    <>
    <Topbar />
      <Navbar />
      <Banner />
      {/* Staggered Sections */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        transition={{ staggerChildren: 0.25 }}
        variants={{
          hidden: { opacity: 0, y: 50 },
          visible: { opacity: 1, y: 0 },
        }}
      >

        <motion.div variants={{ hidden: { opacity: 0, y: 40 }, visible: { opacity: 1, y: 0 } }}>
          <CareersSection />
        </motion.div>
        <motion.div variants={{ hidden: { opacity: 0, y: 40 }, visible: { opacity: 1, y: 0 } }}>
          <CareerForm />
        </motion.div>
        <motion.div variants={{ hidden: { opacity: 0, y: 40 }, visible: { opacity: 1, y: 0 } }}>
          <CareersFAQ />
        </motion.div>
        
      </motion.div>

      <Footer />
    </>
  );
}

export default Offers;
